/*!
 * Habtium: the Habbo universe on your hand.
 *
 * @link https://habtium.es/about
 * @copyright 2006 - 2016 Habtium
 */

/*!
 * Language object.
 *
 * @author Víctor Díaz <victor@axiomer.com>
 */
var Language = {
	code: $('html').attr('lang'),
	strings: {},
	
	init: function () {
		if (Storage) {
			if (App.version == Lockr.get('app.version') && Language.code == Lockr.get('app.language_code'))
				Language.strings = Lockr.get('app.language_strings');
		}
	},
	
	get: function (strings) {
		return new Promise(
			function (resolve) {
				var result = {};
				
				if (!Array.isArray(strings))
					strings = [strings];
				
				strings.forEach(function (value, index) {
					var current;
					var namespace;
					var identifier = value;
					var params;
					
					if (Array.isArray(value)) {
						identifier = value[0];
						params = value[1];
					}
					
					identifier = identifier.split('.');
					namespace = identifier.shift();
					identifier = identifier.join('.');
					
					if (identifier === '')
						identifier = namespace;
					
					var parse = function () {
						current = Language.strings[namespace][identifier];
						
						if (params && params instanceof Object && Object.keys(params).length > 0) {
							$.each(params, function (k, v) {
								current = current.replace('%' + k + '%', v);
							});
						}
					};
					
					var complete = function () {
						result[index] = current;
						result[identifier] = current;
						
						if (index === strings.length - 1)
							resolve(result);
					};
					
					if (!Language.strings[namespace]) {
						Language.getFile(namespace).then(function () {
							if (Language.strings[namespace] && Language.strings[namespace][identifier]) {
								parse();
							} else
								current = identifier;
							
							complete();
						}, function () {
							current = identifier;
							complete();
						});
					} else {
						if(Language.strings[namespace][identifier])
							parse();
						else
							current = identifier;
						
						complete();
					}
				});
			}
		);
	},
	
	getFile: function (namespace) {
		return new Promise(
			function (resolve, reject) {
				$.getJSON('/lang/' + Language.code + '/' + namespace + '.json?' + App.version).done(function (data) {
					Language.strings[namespace] = data;
					
					if (typeof(Storage) !== 'undefined') {
						Lockr.set('app.version', App.version);
						Lockr.set('app.language_code', Language.code);
						Lockr.set('app.language_strings', Language.strings);
					}
					
					resolve();
				}).fail(reject);
			}
		);
	}
};